import React from 'react'
import HomeContainer from '../containers/HomeContainer'

const Home = () => (
	<HomeContainer />
)

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js